import { render, staticRenderFns } from "./settings-employee-payment-permissions-dialog.vue?vue&type=template&id=44902dc8&scoped=true&"
import script from "./settings-employee-payment-permissions-dialog.vue?vue&type=script&lang=js&"
export * from "./settings-employee-payment-permissions-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44902dc8",
  null
  
)

export default component.exports